export const NOTIFICATIONS_FETCH_REQUESTED = 'NOTIFICATIONS_FETCH_REQUESTED'
export const NOTIFICATIONS_FETCH_SUCCESS = 'NOTIFICATIONS_FETCH_SUCCESS'
export const MARKREAD_FETCH_REQUESTED = 'MARKREAD_FETCH_REQUESTED'
export const MARKREAD_FETCH_SUCCESS = 'MARKREAD_FETCH_SUCCESS'
export const MARKUNREAD_FETCH_REQUESTED = 'MARKUNREAD_FETCH_REQUESTED'
export const MARKUNREAD_FETCH_SUCCESS = 'MARKUNREAD_FETCH_SUCCESS'
export const MARKALLREAD_FETCH_REQUESTED = 'MARKALLREAD_FETCH_REQUESTED'
export const MARKALLREAD_FETCH_SUCCESS = 'MARKALLREAD_FETCH_SUCCESS'
